/* IfShe product page (new code, 2026-10-14 redesign). Loaded by sections/main-product.liquid after the options engine.
   1. Mobile gallery dots: follow the Dawn slider (slideChanged) and jump on tap.
   2. Personalisation panel (open by default): when the engine blocks add-to-cart on an empty required field it
      highlights that field and scrolls to it but writes no text in open mode, so we add a short message under the
      field, and clear it as soon as the shopper edits that field. The engine file itself is untouched.
   3. Ring size link: move it right under the ring size control.
   4. "More from the collection" rail: desktop arrows. */
(function () {
  'use strict';

  var strings = {};
  try {
    var s = document.getElementById('IfshePdpStrings');
    if (s) strings = JSON.parse(s.textContent);
  } catch (e) { strings = {}; }

  /* ---------- 0. description: first lines + read more (server renders the clamped state; this only toggles) ---------- */
  function initDescClamp(box) {
    var body = box.querySelector('.ifshe-pdp-desc');
    var btn = box.querySelector('.ifshe-pdp-desc-clamp__toggle');
    if (!body || !btn) return;
    // short descriptions: drop the clamp and the button
    if (body.scrollHeight <= body.clientHeight + 2) { box.classList.remove('is-clamped'); return; }
    btn.addEventListener('click', function () {
      var open = !box.classList.contains('is-expanded');
      box.classList.toggle('is-expanded', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- 1. gallery dots ---------- */
  function initDots(gallery) {
    var dots = gallery.querySelector('[data-ifshe-dots]');
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
    if (!dots || !viewer) return;
    var list = viewer.querySelector('.product__media-list');
    var buttons = Array.prototype.slice.call(dots.querySelectorAll('.ifshe-pdp-dots__dot'));
    function setActive(index) {
      buttons.forEach(function (b, i) {
        var on = i === index;
        b.classList.toggle('is-active', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    }
    function slides() {
      return Array.prototype.slice.call(list.querySelectorAll('.product__media-item')).filter(function (el) {
        return el.clientWidth > 0;
      });
    }
    viewer.addEventListener('slideChanged', function (e) {
      if (e.detail && e.detail.currentPage) setActive(e.detail.currentPage - 1);
    });
    // Fallback for browsers where the slider component has not bound yet: compute from scroll position.
    list.addEventListener('scroll', function () {
      var w = list.clientWidth || 1;
      setActive(Math.round(list.scrollLeft / w));
    }, { passive: true });
    buttons.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var all = slides();
        var target = all[i];
        if (!target) return;
        list.scrollTo({ left: target.offsetLeft - list.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });
  }

  /* ---------- 2. required-field messages for the open personalisation panel ---------- */
  var MSG_CLASS = 'ifshe-pdp-field-msg';

  function fieldMessage(field) {
    var c = field.className || '';
    if (/ifshe-po__field--file/.test(c)) return strings.requiredPhoto || '';
    if (/ifshe-po__field--(text|textarea)/.test(c)) return strings.requiredText || '';
    return strings.requiredChoice || '';
  }

  function clearField(field) {
    if (!field) return;
    field.classList.remove('ifshe-po__field--error');
    var m = field.querySelector('.' + MSG_CLASS);
    if (m) m.parentNode.removeChild(m);
  }

  function initPanel(root) {
    var form = root.closest('form');
    if (!form || form.__ifshePdpBound) return;
    form.__ifshePdpBound = true;
    var notice = root.querySelector('.ifshe-po__notice');

    // Before the engine's own submit handler (capture on document runs ahead of the form's capture listener):
    // reset last attempt's state so each click is judged afresh. The engine never removes its error class itself.
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      Array.prototype.forEach.call(root.querySelectorAll('.ifshe-po__field--error'), clearField);
      if (notice) { notice.textContent = ''; notice.style.display = ''; }
    }, true);

    // After the engine's handler: if it flagged a field, explain it under the field. The engine calls
    // stopPropagation() in its capture listener on the form, which (per the DOM spec) also skips the form's
    // non-capture listeners — so we listen in the capture phase too and look once the dispatch has finished.
    // If the engine already wrote its own notice (photo not ready / add failed), leave that message alone.
    function explain() {
      var bad = root.querySelector('.ifshe-po__field--error');
      if (!bad || bad.querySelector('.' + MSG_CLASS)) return;
      if (notice && notice.style.display === 'block' && notice.textContent) return;
      var text = fieldMessage(bad);
      if (!text) return;
      var p = document.createElement('p');
      p.className = MSG_CLASS;
      p.setAttribute('role', 'alert');
      p.textContent = text;
      bad.appendChild(p);
    }
    form.addEventListener('submit', function () { setTimeout(explain, 0); }, true);

    // Clear the error as soon as that field is touched again.
    function onEdit(e) {
      var field = e.target && e.target.closest ? e.target.closest('.ifshe-po__field') : null;
      if (field && field.classList.contains('ifshe-po__field--error')) clearField(field);
    }
    root.addEventListener('input', onEdit);
    root.addEventListener('change', onEdit);
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.ifshe-po__swatch, .ifshe-po__image-opt, .ifshe-po__upload-btn')) onEdit(e);
    });
  }

  /* ---------- 3. ring size link placement ---------- */
  var RING_LABEL = /ring\s*size|ringgr|ringweite|taille de bague|talla de anillo|misura (dell'?\s*)?anello|ringmaat|ringstorlek|ringst(ø|o)rrelse/i;

  function placeRingLink(scope) {
    var link = scope.querySelector('[data-ifshe-ring-link]');
    if (!link) return;
    var fields = scope.querySelectorAll('.ifshe-po__field');
    for (var i = 0; i < fields.length; i++) {
      if (RING_LABEL.test(fields[i].getAttribute('data-field') || '')) {
        fields[i].appendChild(link);
        link.classList.add('is-placed');
        return;
      }
    }
    // Ring size as a real Shopify option (variant picker)
    var sets = scope.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input');
    for (var j = 0; j < sets.length; j++) {
      var lg = sets[j].querySelector('legend, label');
      if (lg && /size|gr(ö|o)(ß|ss)e|taille|talla|misura|maat|storlek|størrelse/i.test(lg.textContent)) {
        sets[j].appendChild(link);
        link.classList.add('is-placed');
        return;
      }
    }
  }

  /* ---------- 4. rail arrows ---------- */
  function initRail(rail) {
    var list = rail.querySelector('[data-ifshe-rail-list]');
    if (!list) return;
    var arrows = rail.querySelectorAll('.ifshe-pdp-more__arrow');
    function sync() {
      var max = list.scrollWidth - list.clientWidth - 2;
      Array.prototype.forEach.call(arrows, function (a) {
        var dir = parseInt(a.getAttribute('data-dir'), 10);
        a.disabled = dir < 0 ? list.scrollLeft <= 2 : list.scrollLeft >= max;
      });
      rail.classList.toggle('is-scrollable', max > 2);
    }
    Array.prototype.forEach.call(arrows, function (a) {
      a.addEventListener('click', function () {
        var dir = parseInt(a.getAttribute('data-dir'), 10);
        list.scrollBy({ left: dir * list.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
    list.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.ifshe-pdp [data-ifshe-desc-clamp]'), initDescClamp);
    Array.prototype.forEach.call(document.querySelectorAll('.ifshe-pdp media-gallery'), initDots);
    Array.prototype.forEach.call(document.querySelectorAll('.ifshe-pdp .ifshe-po[data-ifshe-options]'), initPanel);
    Array.prototype.forEach.call(document.querySelectorAll('.ifshe-pdp .product__info-container'), placeRingLink);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ifshe-rail]'), initRail);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
